import $ from 'jquery';

export default function (e) {
	const $target = $(e.target);
	const $item = $target.closest(this.$item);
	const $el = $target.closest(this.$el);
	const $items = $el.find(this.$item);
	const $content = $item.find(this.$items);
	const $otherContent = $el.find(this.$items);

	if (!$item.hasClass(this.opened)) {
		$items.removeClass(this.opened);
		$item.addClass(this.opened);
		const $inner = $item.find(this.options.dom.inner);
		let height = 0;
		$inner.each(function () {
			height += $(this).outerHeight(true);
		});
		$otherContent.css('height', 0);
		$content.css('height', height);
	}
	else {
		$content.css('height', 0);
		$item.removeClass(this.opened);
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/accordeon/accordeon.js
 **/